import React, { useContext } from 'react';
import cx from 'classnames';
import Lottie from 'react-lottie';
import animationData from '~/lotties/onboarding/loading-bicycle_white.json';
import { LoadingProgress } from '@vimily/bonjoro-ui-components-v2/LoadingProgress';
import RecorderDrawerContext from '../../Context';

export const lottieOptions = {
  loop: true,
  autoplay: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};
export function UploadingScreen() {
  const { uploadProgress } = useContext(RecorderDrawerContext);
  return (
    <div
      className={cx([
        'absolute v2-animate-fade-in-150 w-full h-full z-99 flex justify-center',
        'rounded-2xl md:w-[55%] md:h-[482px] md:top-[67px]',
      ])}
    >
      <div
        className={cx([
          'flex flex-col gap-y-5 items-center w-full h-full',
          'md:mx-6 v2-bg-black/50 justify-center',
        ])}
      >
        <Lottie
          options={{ animationData: animationData, ...lottieOptions }}
          width={180}
          height={180}
        />
        <span className='text-[28px] font-bold v2-text-white'>Uploading</span>
        <LoadingProgress className='w-[80%]' progress={uploadProgress} />
      </div>
    </div>
  );
}
